module.exports = __webpack_public_path__ + "media/images/Group 4 Copy 5-f15a552e718af0ce5884fb501afe3606.jpg";